<template lang="pug">
vm-row(vm-w="12")
  vm-col(vm-type="flex" vm-align="center" vm-w=12)
    TitleCard()
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total")' :textValue='project.total_oc_mxn' :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice")' :textValue='totalInvoicedAmountMxn' :currency="'MXN'" type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid")' :textValue='totalPaymentsAmountMxn' :currency="'MXN'" color="green" type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.pending_amount")' :textValue='pendingPayableMxn' :currency="'MXN'" type='text' color="primary")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_without_iva")' :textValue='project.subtotal_oc_mxn' :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice_without_iva")' :textValue='totalInvoicedAmountMxnWithoutIva' :currency="'MXN'" type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid_without_iva")' :textValue='totalPaymentsAmountMxnWithoutIva' :currency="'MXN'" color="green" type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.pending_amount_without_iva")' :textValue='pendingPayableMxnWithoutIva' :currency="'MXN'" type='text' color="primary")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money__large" vm-align="center" vm-w=12)
      MoneyCard(:title='$t("projects.invoices_mxn")' :textValue='totalInvoicedAmountMxn' type='title-large')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    ProjectTablesDashboard(:data='invoicesPurchaseOrderMxn', :columns='columns', :status='status')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total")' :textValue='project.total_oc_usd' :currency="'USD'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice")' :textValue='totalInvoicedAmountUsd' type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid")' :textValue='totalPaymentsAmountUsd' color="green" type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.pending_amount")' :textValue='pendingPayableUsd' type='text' color="primary")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_without_iva")' :textValue='project.subtotal_oc_usd' :currency="'USD'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice_without_iva")' :textValue='totalInvoicedAmountUsdWithoutIva' type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid_without_iva")' :textValue='totalPaymentsAmountUsdWithoutIva' color="green" type='text')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.pending_amount_without_iva")' :textValue='pendingPayableUsdWithoutIva' type='text' color="primary")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money__large" vm-align="center" vm-w=12)
      MoneyCard(:title='$t("projects.invoices_usd")' :textValue='totalInvoicedAmountUsd' type='title-large')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    ProjectTablesDashboard(:data='invoicesPurchaseOrderUsd', :columns='columns', :status='status')
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectsDashboard')
const TitleCard = () => import('@/components/aditionals/TitleCard.vue')
const MoneyCard = () => import('@/components/aditionals/MoneyCard.vue')
const ProjectTablesDashboard = () => import('@/components/aditionals/ProjectTablesDashboard.vue')

export default {
  name: 'ProjectDasboard',
  components: {
    TitleCard,
    MoneyCard,
    ProjectTablesDashboard
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['id', 'purchase_order_display', 'subtotal', 'tax_amount', 'total', 'currency', 'status', 'created_at', 'user_display'],
    status: [
      {
        value: 'paid',
        color: 'success'
      },
      {
        value: 'partially_paid',
        color: 'primary'
      },
      {
        value: 'pending',
        color: 'warning'
      }
    ]
  }),
  computed: {
    ...mapGetters(['project', 'invoicesPurchaseOrderUsd', 'invoicesPurchaseOrderMxn', 'paymentsMxn', 'paymentsUsd']),
    totalInvoicedAmountUsdWithoutIva () {
      return this.invoicesPurchaseOrderUsd ? this.invoicesPurchaseOrderUsd.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : 0
    },
    totalInvoicedAmountMxnWithoutIva () {
      return this.invoicesPurchaseOrderMxn ? this.invoicesPurchaseOrderMxn.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : 0
    },
    totalPaymentsAmountUsdWithoutIva () {
      return this.paymentsUsd ? parseFloat(this.paymentsUsd.reduce((acc, crr) => acc + +crr.subtotal, 0)) : 0
    },
    totalPaymentsAmountMxnWithoutIva () {
      return this.paymentsMxn ? parseFloat(this.paymentsMxn.reduce((acc, crr) => acc + +crr.subtotal, 0)) : 0
    },
    pendingPayableUsdWithoutIva () {
      return parseFloat(this.project.subtotal_oc_usd) - parseFloat(this.totalInvoicedAmountUsdWithoutIva)
    },
    pendingPayableMxnWithoutIva () {
      return parseFloat(this.project.subtotal_oc_mxn) - parseFloat(this.totalInvoicedAmountMxnWithoutIva)
    },

    totalInvoicedAmountUsd () {
      return this.invoicesPurchaseOrderUsd ? this.invoicesPurchaseOrderUsd.reduce((acc, crr) => { return +acc + +crr.total }, 0) : 0
    },
    totalInvoicedAmountMxn () {
      return this.invoicesPurchaseOrderMxn ? this.invoicesPurchaseOrderMxn.reduce((acc, crr) => { return +acc + +crr.total }, 0) : 0
    },
    totalPaymentsAmountUsd () {
      return this.paymentsUsd ? parseFloat(this.paymentsUsd.reduce((acc, crr) => acc + +crr.total, 0)) : 0
    },
    totalPaymentsAmountMxn () {
      return this.paymentsMxn ? parseFloat(this.paymentsMxn.reduce((acc, crr) => acc + +crr.total, 0)) : 0
    },
    pendingPayableUsd () {
      return parseFloat(this.project.total_oc_usd) - parseFloat(this.totalInvoicedAmountUsd)
    },
    pendingPayableMxn () {
      return parseFloat(this.project.total_oc_mxn) - parseFloat(this.totalInvoicedAmountMxn)
    }
  },
  methods: {
    ...mapActions([])
  }
}
</script>
<style lang="scss">
.section-money {
  padding: 5px;
}
.section-money {
  &__large {
    padding: 5px;
    .card-custom {
      height: 100px;
    }
  }
}
</style>
